import React from 'react';
import { ExcelTableCellProps } from './TableCell';
import { observer } from 'mobx-react';

@observer
export default class ExcelTableCellSpan extends React.Component<ExcelTableCellProps, any> {
    render() {
        const { cell, contentType } = this.props;
        if (contentType == 'content') {
            const { evalue } = cell;
            return (
                <span {...cell.cellProps} dangerouslySetInnerHTML={{ __html: `${evalue}` }}></span>
            )
        } else if (contentType == 'index') {
            return (
                <span {...cell.cellProps} className="serialNumber" >{this.props.index + 1}</span>
            )
        }else {
            return (
                <div {...cell.cellProps} dangerouslySetInnerHTML={{ __html: this.transCellText(cell.evalue) }}></div>
            )
        }
    }
    transCellText = (content) => {
        if (content === null || typeof content === "undefined")
            return "";
        return content.replace(/(\r\n|\r|\n)/g, "</br>").replace(/ /g, "&nbsp;");
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/CellSpan.tsx